import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M10.0000003,0 C15.5228478,0 20.0000003,4.4771525 20.0000003,10 C20.0000003,15.5228475 15.5228478,20 10.0000003,20 C4.47715283,20 3.33e-07,15.5228475 3.33e-07,10 C3.33e-07,4.4771525 4.47715283,0 10.0000003,0 Z M10.0000003,12.9166666 C9.30964439,12.9166666 8.75000033,13.4763107 8.75000033,14.1666666 C8.75000033,14.8570226 9.30964439,15.4166666 10.0000003,15.4166666 C10.6903563,15.4166666 11.2500003,14.8570226 11.2500003,14.1666666 C11.2500003,13.4763107 10.6903563,12.9166666 10.0000003,12.9166666 Z M10.0000003,3.75 C9.30964439,3.75 8.75000033,4.30964406 8.75000033,5 L8.75000033,10 C8.75000033,10.6903559 9.30964439,11.25 10.0000003,11.25 C10.6903563,11.25 11.2500003,10.6903559 11.2500003,10 L11.2500003,5 C11.2500003,4.30964406 10.6903563,3.75 10.0000003,3.75 Z"
      transform="translate(2 2)"
      fill={fill}
    />
  </g>
);

export default Icon;
